var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"base-checkbox",on:{"click":_vm.change}},[_c('van-checkbox',{attrs:{"checked-color":"#ffab11","icon-size":"16px"},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}}),_c('span',{staticClass:"text"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }